// Helpers del tab Dashboard (cockpit ejecutivo por proyecto): semáforos por criterio
// (avance, margen, incidencia, fase) y catálogos de safety/incidencias. El resto del
// motor (score de riesgo, RAG, penalidad) se reutiliza del Resumen. Umbrales del diseño.

// Umbral de riesgo significativo del cockpit (I×P ≥ 12), como en el diseño.
export const SIGNIFICANT_RISK = 12

// Colores de semáforo (punto/indicador) del diseño.
export const SEM = { green: '#27ae60', amber: '#f0a500', red: '#e53e3e' }

// Acentos de texto de los KPIs (tono más oscuro para valores grandes).
export const ACCENT = { good: '#1e8449', warn: '#b9770e', bad: '#c0392b' }

// Catálogos manuales de safety (código → se traduce en el componente).
export const PHASE_STATUSES = ['not_started', 'in_progress', 'completed']

// Gravedad de una incidencia según el código de clase (IssueClass). El dashboard es solo para
// tkelevator, cuyo catálogo de clases es L (Leve) / G (Grave) / MG (Muy grave) / WE STOP (paro de
// obra). De ahí derivamos el nivel (para agrupar los KPIs) y el color del semáforo.
export const INCIDENT_SEVERITY = {
  'WE STOP': { level: 'we_stop', color: 'red' },
  MG: { level: 'very_serious', color: 'red' },
  G: { level: 'serious', color: 'amber' },
  L: { level: 'minor', color: 'green' },
}

export function incidentSeverity (code) {
  return INCIDENT_SEVERITY[(code || '').toString().trim().toUpperCase()] || { level: 'other', color: 'grey' }
}

// Semáforo de avance: verde si (real − plan) ≥ −5 p.p., ámbar ≥ −10, rojo peor.
export function progressColor (real, plan) {
  const d = (Number(real) || 0) - (Number(plan) || 0)
  if (d >= -5) return 'green'
  if (d >= -10) return 'amber'
  return 'red'
}

// Semáforo de margen (fracciones): verde si (actual − comercial) ≥ 0 p.p., ámbar ≥ −2, rojo peor.
export function marginColor (commercial, actual) {
  const d = ((Number(actual) || 0) - (Number(commercial) || 0)) * 100
  if (d >= 0) return 'green'
  if (d >= -2) return 'amber'
  return 'red'
}

// Semáforo de una fila de incidencia: verde si cerrada; si abierta, según la gravedad de su
// clase (WE STOP/MG = rojo, G = ámbar, L = verde) o rojo si lleva abierta más de 30 días.
export function incidentColor (row) {
  if (row.status === 'closed') return 'green'
  const days = Number(row.daysOpen) || 0
  const color = incidentSeverity(row.classCode).color
  if (color === 'red' || days > 30) return 'red'
  if (color === 'amber') return 'amber'
  return 'green'
}

// Semáforo de una fase de safety según sus incidencias abiertas: ≥2 rojo, 1 ámbar, 0 verde.
export function phaseColor (row) {
  const open = Number(row.openIncidents) || 0
  if (open >= 2) return 'red'
  if (open === 1) return 'amber'
  return 'green'
}
